<template>
  <footer class="footer">
    <div class="container-fluid">
      <p class="copyright pull-right">
        <!-- 2020 = current year -->
        <!-- copyright ©
        2020 > -->
        Copyright 2020
        <a href="http://bib.com.mm/">BIB Co., Ltd</a>, make your better world
      </p>
    </div>
  </footer>
</template>

<script>
export default {
  name: "Footer"
}
</script>